"use client";

import Crosshair from "../../../helpers/chart/plugins/crosshair";
import { CategoryScale, ChartData, ChartOptions } from "chart.js";
import { Chart } from "chart.js/auto";
import { Line } from "react-chartjs-2";

Chart.register(CategoryScale);
Chart.register(Crosshair);

export type AreaChartParams = {
  data: ChartData<"line">;
  options?: ChartOptions<"line">;
};

const AreaChart = ({ data, options }: AreaChartParams) => {
  const areaData = {
    ...data,
    datasets: data.datasets.map((dataset) => ({
      ...dataset,
      fill: true,
      backgroundColor: function (context: any) {
        const chart = context.chart;
        const { ctx, chartArea } = chart;

        if (!chartArea) {
          return "rgba(0,0,0,0)";
        }

        // 建立線性漸層
        const gradient = ctx.createLinearGradient(
          0,
          chartArea.top,
          0,
          chartArea.bottom
        );
        gradient.addColorStop(0, `${dataset.borderColor}88`); // 上方顏色
        gradient.addColorStop(1, `${dataset.borderColor}00`); // 下方顏色
        return gradient;
      },
    })),
  };

  return data ? <Line data={areaData} options={options} /> : null;
};

export default AreaChart;
